import { LAST_AUTHENTICATED_ROUTE_KEY, STRIPE_SUBSCRIPTION_RETURN_PATH_KEY } from '@/storage/keys';

const AUTH_PATH_PREFIXES = ['/login', '/register'];
export const LOGIN_HASH_HREF = '/#/login';

const normalizePathValue = (path) => (Array.isArray(path) ? path[0] : path);

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage;
};

export const isAuthPageName = (routeName) => routeName === 'login' || routeName === 'register';

export const isSafeRedirectPath = (path) => {
  const candidate = normalizePathValue(path);

  if (typeof candidate !== 'string') {
    return false;
  }

  const trimmed = candidate.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return false;
  }

  return !AUTH_PATH_PREFIXES.some((prefix) => trimmed.startsWith(prefix));
};

export const getLastAuthenticatedRoute = () => {
  try {
    const storage = getStorage();
    if (!storage) {
      return null;
    }

    const candidate = storage.getItem(LAST_AUTHENTICATED_ROUTE_KEY);
    return isSafeRedirectPath(candidate) ? candidate : null;
  } catch (error) {
    return null;
  }
};

export const setLastAuthenticatedRoute = (path) => {
  try {
    const storage = getStorage();
    const candidate = normalizePathValue(path);
    if (!storage || !isSafeRedirectPath(candidate)) {
      return;
    }

    storage.setItem(LAST_AUTHENTICATED_ROUTE_KEY, candidate);
  } catch (error) {
    // Ignore storage write errors.
  }
};

/**
 * Where a signed-in user lands: a safe `redirectPath`, otherwise Home — or the
 * API overview for API-only tenants (`portal_mode = api`), who have no Home.
 */
export function getDemoReturnPath() {
  try {
    const path = JSON.parse(window.sessionStorage.getItem(STRIPE_SUBSCRIPTION_RETURN_PATH_KEY) || 'null');
    const drafts = {
      '/tools/bidding-strategy/new': 'bidding',
      '/tools/imbalance-benchmark/new': 'imbalance',
      '/tools/forward-benchmark/new': 'forward',
      '/tools/shadow-trading/new': 'shadow',
    };
    const tool = typeof path === 'string' && drafts[path.split('?')[0]];
    return tool && window.sessionStorage.getItem(`pf_demo_draft:${tool}`) && isSafeRedirectPath(path) ? path : null;
  } catch { return null; }
}

export const resolveAuthenticatedLandingPath = (redirectPath, { apiOnly = false } = {}) => {
  const candidate = normalizePathValue(redirectPath);
  if (isSafeRedirectPath(candidate)) {
    return candidate;
  }

  return apiOnly ? '/api' : getDemoReturnPath() || '/';
};

export const resolveAuthenticatedLandingHash = (redirectPath) =>
  `/#${resolveAuthenticatedLandingPath(redirectPath)}`;

export const redirectToLoginPage = (location = typeof window === 'undefined' ? null : window.location) => {
  if (!location) {
    return;
  }

  location.href = LOGIN_HASH_HREF;
};
